import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: block;
`;

export const Container = styled.div`
  ${({ theme }) => css`
    padding: 0 24px 80px;

    @media (max-width: ${theme.breakpoints.md}) {
      padding: 24px 24px 80px;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex: 1;
    margin-top: 8px;

    @media (max-width: ${theme.breakpoints.md}) {
      margin-top: 0;
    }
  `}
`;

export const HeaderRow = styled.div`
  ${() => css`
    border-radius: 16px;
  `}    
`;

export const FilterWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    border-radius: 16px;
  `}
`;
